import { h } from 'preact'; /** @jsx h */
import { useEffect, useState } from 'preact/hooks';

import './FooterCTA.scss';

const FooterCTA = ({
    href = '/gave/',
    linkText = 'Støtt oss',
    color = 'primary',
    bgColor = 'off-white',
    textColor = 'all-black'
}) => {
    const [isCtaShown, toggleCtaShown] = useState(false);
    let lastScrollTop = 0;

    // Scroll event listener
    const handleScroll = () => {
        if (window.innerWidth < 1150) {
            const st = window.scrollY || document.documentElement.scrollTop;
            if (st > lastScrollTop && st > 250) {
                // downscroll
                toggleCtaShown(true);
            } else if (st < lastScrollTop - 10 || st < 250) {
                // upscroll
                toggleCtaShown(false);
            }
            lastScrollTop = st <= 0 ? 0 : st;
        }
    };

    // useEffect for scroll event listener
    useEffect(() => {
        if (window) {
            window.addEventListener('scroll', handleScroll);
        }
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    return (
        <div
            className={`footer-cta ${isCtaShown ? 'show' : ''} ${bgColor && `bg-color-${bgColor}`}`}
        >
            <a
                className={`cta-btn ${color && `color-${color}`}  ${
                    textColor && `text-color-${textColor}`
                }`}
                href={href}
            >
                <span>
                    <span dangerouslySetInnerHTML={{ __html: linkText }} />
                </span>
                <span className="material-symbols-outlined">arrow_forward</span>
            </a>
        </div>
    );
};

export default FooterCTA;
